// extracted by mini-css-extract-plugin
var _1 = "EditEmailModal-module__emailWrapper--LSOBl";
export { _1 as "emailWrapper" }
